import axios from "axios";
import { GetUserAuthToken } from "./config";
import { checkUserLogin, logoutAndClearCache } from "./utils";


// to prevent overwriting the global axios config
const myAxios = axios.create();

const getUserToken = () => {
  if (typeof localStorage !== "undefined") {
    return GetUserAuthToken();
    // || GetAdminUserToken();
  }

  return "";
};

const axiosConfig = {
  headers: {
    "x-access-request-source": "olalekan",
    "x-access-username": process.env.REACT_API_USERNAME,
    "x-access-secret": process.env.REACT_API_SECRET,
    "x-access-token": getUserToken(),
  },
};

myAxios.interceptors.request.use((req) => {
  req.headers = axiosConfig.headers;
  return req;
});

myAxios.interceptors.response.use(
  (res) => res,
  (err) => {
    // if (err.response.status === 404) {
    //   throw new Error(`${err.config.url} not found`);
    // }
    console.log("Error in request", err ? err.message : err);
    console.log(err)
    if (err && err.response && err.response.status === 401) {

      logoutAndClearCache();
      checkUserLogin();
    }
    throw err;
  }
);

export default myAxios;
